import React from "react";
import { useCountdown } from "../../hooks";

interface CountdownTimerProps {
  targetDate: number;
  label: string;
}

export const CountdownTimer: React.FC<CountdownTimerProps> = ({
  targetDate,
  label,
}) => {
  const [days, hours, minutes, seconds] = useCountdown(targetDate * 1000);
  return days + hours + minutes + seconds <= 0 ? (
    <p className="text-[22px] mt-[67px]">Expired!</p>
  ) : (
    <div className="flex flex-col  items-center mt-[67px]">
      <p className="text-[22px] text-auctionMid">{label}</p>
      <p className=" text-[33px] font-bold text-center">
        {!!days && `${days} days`} {!!hours && `${hours} hours`}{" "}
        {!!minutes && `${minutes} minutes`} {!!seconds && `${seconds} seconds`}
      </p>
    </div>
  );
};

export default CountdownTimer;
